export default "__VITE_ASSET__BJlGoocc__"